"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const react_1 = __importStar(require("react"));
const input_1 = __importDefault(require("../input"));
const building_blocks_ui_acko_analytics_1 = require("@acko-tech/building-blocks.ui.acko-analytics");
const helpers_1 = __importDefault(require("./../utils/helpers"));
// TODO - move to uitls -
// const emailRegex = '^[w-.]+@([w-]+.)+[w-]{2,4}$';
const emailRegexp = new RegExp(/^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i);
const phoneRegex = new RegExp('^[6-9][0-9]{9}$', 'i');
const PHONE = 'phone';
const EMAIL = 'email';
const PhoneEmailInput = (_a) => {
    var { setParentInputType, setParentErrorStatus, setParentInputValue } = _a, props = __rest(_a, ["setParentInputType", "setParentErrorStatus", "setParentInputValue"]);
    const [touched, setTouched] = (0, react_1.useState)(false);
    const [hasError, setHasError] = (0, react_1.useState)(true);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)('');
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const [inputEventSent, setInputEventSent] = (0, react_1.useState)(false);
    const handleValidation = () => {
        let errors = '';
        if (!inputValue) {
            setHasError(true);
            errors = 'This field is required';
        }
        else if (phoneRegex.test(inputValue)) {
            setParentInputType(PHONE);
            !inputEventSent && (0, building_blocks_ui_acko_analytics_1.trackEvent)('enter_phone_number_before_clicking_continue', { communication_phone: inputValue });
            setHasError(false);
            setInputEventSent(true);
        }
        else if (emailRegexp.test(inputValue)) {
            setParentInputType(EMAIL);
            !inputEventSent && (0, building_blocks_ui_acko_analytics_1.trackEvent)('enter_email_id_before_clicking_continue', { communication_email: inputValue });
            setHasError(false);
            setInputEventSent(true);
        }
        else {
            setHasError(true);
            errors = 'Please provide a valid Email or phone number';
        }
        setErrorMsg(errors);
    };
    const handleOnChange = (e) => {
        setInputValue(e.target.value);
        setParentInputValue(e.target.value);
    };
    (0, react_1.useEffect)(() => {
        (0, helpers_1.default)(() => { handleValidation(); }, 1000)();
    }, [inputValue]);
    (0, react_1.useEffect)(() => {
        console.log('has errror....', hasError);
        setParentErrorStatus(hasError);
    }, [hasError]);
    return (react_1.default.createElement(input_1.default, { labelText: "Email or mobile number", hasError: hasError && touched, errMsg: errorMsg, onChange: handleOnChange, onBlur: () => {
            setTouched(true);
            handleValidation();
        }, value: inputValue, type: "text", className: "", name: "phoneEmail" }));
};
exports.default = PhoneEmailInput;
//# sourceMappingURL=phone-email-input.js.map